import { MEDIA } from "@/data/media";
import { FOUNDATION } from "@/data/content";
import { Reveal } from "@/components/Reveal";

export const FoundationSection = () => {
  return (
    <section
      data-testid="foundation-section"
      className="section"
      style={{ backgroundColor: "var(--bg-2)" }}
    >
      <div className="container-fx">
        <div className="grid items-center gap-12 lg:grid-cols-2">
          <Reveal delay={0.1} className="order-2 lg:order-1">
            <div
              className="relative overflow-hidden"
              style={{
                borderRadius: "var(--radius-lg)",
                border: "1px solid var(--border-c)",
                aspectRatio: "4 / 5",
              }}
            >
              <img
                src={MEDIA.foundationImage}
                alt="Mobility and activation"
                className="h-full w-full object-cover"
                loading="lazy"
              />
              <div
                className="absolute inset-0"
                style={{
                  background:
                    "linear-gradient(to top, rgba(11,10,8,0.55), rgba(11,10,8,0.05))",
                }}
              />
            </div>
          </Reveal>

          <Reveal className="order-1 lg:order-2">
            <div>
              <p className="eyebrow">{FOUNDATION.eyebrow}</p>
              <h2
                className="display mt-5"
                style={{ fontSize: "clamp(2.2rem, 5vw, 3.6rem)", fontWeight: 500 }}
              >
                {FOUNDATION.headline_lead}{" "}
                <span className="accent-italic">
                  {FOUNDATION.headline_accent}
                </span>
              </h2>
              <p
                className="font-serif mt-5"
                style={{
                  fontSize: "1.2rem",
                  color: "var(--text)",
                  lineHeight: 1.5,
                }}
              >
                {FOUNDATION.intro}
              </p>
              {FOUNDATION.body.map((p, i) => (
                <p
                  key={i}
                  className="mt-4 max-w-xl"
                  style={{
                    color: "var(--text-2)",
                    fontSize: "0.94rem",
                    lineHeight: 1.7,
                  }}
                >
                  {p}
                </p>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
